import * as React from "react";
import CardSummary from "../../../../../../../modules/PaymentMethodsList/Payments/Adyen/AdyenPaymentCard/AdyenPaymentCardSummary.js";
const CreditcardSummary = (props) => /* @__PURE__ */ React.createElement(CardSummary, { ...props });
export {
  CreditcardSummary as default
};
//# sourceMappingURL=CreditcardSummary.js.map
